import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchCategory, fetchProducts } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewCategory from '../components/categories/ViewCategory';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  categories: PropTypes.object,
  category: PropTypes.object,
  products: PropTypes.any,
  params: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class CategoryViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    const query = this.props.query;
    const router = this.props.router;
    if (!query.page) {
      query.page = 1;
      query.categoryId = this.props.params.id;
      router.push({ pathname: location.pathname, query });
    }
    this.props.dispatch(fetchProducts(query));
    this.props.dispatch(fetchCategory(this.props.params.id));
  }
  componentDidMount() {
    // const fetchCategoryProducts = { categoryId: this.props.params.id };
    // this.props.dispatch(fetchCategory(this.props.params.id));
    // this.props.dispatch(fetchProducts(fetchCategoryProducts));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="category component" style={authPage}>
        <h2>View Category</h2>
        <ViewCategory
          category={this.props.categories.category}
        />
      </div>
    );
  }
}

CategoryViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CategoryViewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    category: state.categories.category,
    categories: state.categories,
    products: state.products.results,
    productsMeta: state.products.meta,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(CategoryViewPage));



// WEBPACK FOOTER //
// ./src/containers/CategoryViewPage.js